/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import {deleteLocalStorage, getLocalStorage, setLocalStorage} from '@ion/core/src/capabilities/storage';

export type PreviousPage = {
  route: string,
  query: string
}

const PREVIOUS_PAGE_STORAGE_KEY = 'previousPage';
const QUERY_PARAMS_STORAGE_KEY  = 'queryParams';

/**
 * Provides a utility function to store previous page.
 */
export const storePreviousPage = (page: string, query: string): void => {
  setLocalStorage(PREVIOUS_PAGE_STORAGE_KEY, page);
  setLocalStorage(QUERY_PARAMS_STORAGE_KEY, query);
};

/**
 * Defines type for persisted PreviousPage.
 */

/**
 * Provides a utility function to retrieve previous page.
 */
export const getPreviousPage = (): PreviousPage => {
  return {
    route : getLocalStorage(PREVIOUS_PAGE_STORAGE_KEY),
    query : getLocalStorage(QUERY_PARAMS_STORAGE_KEY)
  };
};

/**
 * Provides a utility function to delete previous page.
 */
export const deletePreviousPage = (): void => {
  deleteLocalStorage(PREVIOUS_PAGE_STORAGE_KEY);
  deleteLocalStorage(QUERY_PARAMS_STORAGE_KEY);
};
